import { ActivatedRoute, ResolveFn, Router, UrlSegment } from '@angular/router';
import { map, take, switchMap } from 'rxjs';
import { inject } from '@angular/core';
import { CompanyService } from '../../dashboard/services/company/company.service';
import { CompanyComponentsService } from '../services/company-components.service';
import { CompanyV2 } from '../models/company/company-v2';

export const companyDataResolver: ResolveFn<CompanyV2[]> = (route) => {
  const companyService = inject(CompanyService);
  const companyComponentsService = inject(CompanyComponentsService);

  return companyService.loadCompaniesData().pipe(
    take(1),
    switchMap((companies) => {
      if (companies.length === 0) {
        return [];
      }

      const activeProject: number = route.queryParams[
        'activeProject'
      ] as number;

      let activeCompany: CompanyV2 | undefined;

      if (activeProject) {
        activeCompany = companies.find(
          (company) => company.CompanyId === +activeProject,
        );
      }

      const selectedCompany = activeCompany || companies[0];
      companyService.setActiveCompany(selectedCompany, false);
      companyService.companiesSignal.set(companies);

      return companyComponentsService
        .getCompanyComponents(selectedCompany.CompanyId)
        .pipe(
          take(1),
          map(() => companies),
        );
    }),
  );
};
